import { useCallback, useEffect, useState } from 'react';
import { checkForUpdates, installUpdate, isDesktop } from '../lib/desktop-bridge';

// ANX-092 (v2: check + prompt) — проверка обновлений desktop-приложения.
//
// Первая версия вызывала единую Rust-команду, которая ТИХО ставила апдейт и
// перезапускала приложение прямо на старте — это его валило (см.
// history/ANX-092.md). Теперь: на старте только check (версия для баннера
// UpdateBanner), установка — отдельной командой по явному клику пользователя.
//
// На бинарях ≤0.1.12 команды `check_for_updates` нет — bridge глотает reject
// в null, баннер не показывается. В браузере — no-op.
export function useDesktopUpdater(): {
  availableVersion: string | null;
  installing: boolean;
  install: () => void;
} {
  const [availableVersion, setAvailableVersion] = useState<string | null>(null);
  const [installing, setInstalling] = useState(false);

  useEffect(() => {
    if (!isDesktop()) return;
    let cancelled = false;
    void checkForUpdates().then((v) => {
      if (!cancelled && v) setAvailableVersion(v);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const install = useCallback(() => {
    setInstalling(true);
    // Успех = приложение перезапустится само (app.restart() в Rust);
    // ошибка — возвращаем кнопку, можно повторить.
    void installUpdate().catch(() => setInstalling(false));
  }, []);

  return { availableVersion, installing, install };
}
